import React, { FC, ReactNode, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useCurrentProductId } from '@adsk/alloy-provider';
import { REPORT_TYPES, report } from '@adsk/exo-skeleton-api';
import { DEFAULT_TITLE } from '../../consts';
import getProductTitle from '../../utils/getProductTitle';
import i18n from '../../utils/i18n';
import RouteTitle from '../RouteTitle/RouteTitle';

type ToolProps = {
  children?: ReactNode;
  titleKey: string;
};

const Tool: FC<ToolProps> = ({ children, titleKey }) => {
  const productId = useCurrentProductId();

  const title = useMemo(() => {
    if (productId && titleKey) {
      const toolTitle = i18n.t(titleKey);
      const productTitle = getProductTitle(productId);

      if (!productTitle) {
        void report({
          type: REPORT_TYPES.error,
          value: `Product: "${productId}" title missing, fallback to default title`,
          context: {
            productId,
          },
        });

        return DEFAULT_TITLE;
      }

      return `${toolTitle} - ${productTitle}`;
    }

    return DEFAULT_TITLE;
  }, [titleKey, productId]);

  return <RouteTitle title={title}>{children}</RouteTitle>;
};

Tool.propTypes = {
  children: PropTypes.node,
  titleKey: PropTypes.string.isRequired,
};

export default Tool;
